import { Stack } from '@zet/design-system'

export const UserConsentContent = ({ consentData }: { consentData: any }) => {
  return (
    <Stack className="px-3 pb-8 pt-3">
      <div
        dangerouslySetInnerHTML={{
          __html: `<!DOCTYPE html>
                    <html>
                    <head>
                      <link rel="stylesheet" href="https://use.typekit.net/tcd8cwi.css">
                      <style>
                        a:link {
                        text-decoration: none;
                        color: #2075F0;
                        font-weight: 700;
                        }
                        a:visited {
                          text-decoration: none;
                          color: #2075F0;
                          font-weight: 700;
                          }
                          .consent-body {
                            color: #596379;
                            font-family: 'Graphie-Regular';
                          }
                      </style>
                      <script>
                        document.getElementById("consent-body").addEventListener("click", function(event){
                          event.stopPropagation()
                        });
                      </script>
                    </head>
                    <body style="font-size: 24px; font-family: 'graphie'; color:'#596379';">
                        <div>
                          <!-- Iterate through consents array -->
                          <div class="consent-body" >
                            ${consentData?.genericConsent}
                          </div>
                          ${consentData?.kreditBeeConsent
                            ?.map(
                              (consent, index) => `
                          <div class="consent">
                              <div class="consent-body" >
                                ${consent.consentBody}
                              </div>
                          </div>
                          `
                            )
                            .join('')}
                            
                        </div>
                    </body>
                    </html>
  `,
        }}
      ></div>
    </Stack>
  )
}
